import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ProductLookup from "common/productLookup";
import Button from "react-bootstrap/Button";
import CustomModal from "common/modal";
import CustomTooltip from "common/tooltip";
import { getlaborCodeOptions } from "store/siteRepo/actionCreator";
import rightArrow from "svg/rightArrow.svg";
import deleteIconBlue from "svg/delete_blue.svg";
import { toast } from "react-toastify";
import isEmpty from "lodash/isEmpty";
import axios from "services/config";
import Modal from "react-bootstrap/Modal";
import ProgressBar from "react-bootstrap/ProgressBar";
import Select from "react-select";
import { sortBy } from "lodash";

const ProductSummary = ({ title, productName, salesNumber, category }) => (
  <div className="col-5">
    <div className="d-flex flex-column">
      <h4 className="heading mb-3">{title}</h4>
      <div className="selected-product-info col-10">
        <div className="d-flex justify-content-between product-details">
          <span className="label">Product Name</span>
          <span className="value">{productName ?? "NA"}</span>
        </div>
        <div className="d-flex justify-content-between product-details">
          <span className="label">Sales Number</span>
          <span className="value">{salesNumber ?? "NA"}</span>
        </div>
        <div className="d-flex justify-content-between product-details">
          <span className="label">Category</span>
          <span className="value">{category ?? "NA"}</span>
        </div>
      </div>
    </div>
  </div>
);

const ProductUpdatedBy = ({ selectedProduct, sites }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sub } = useSelector((state) => state.loggedInUser);
  const [updatedBySelectedProduct, setUpdatedBySelectedProduct] = useState({});
  const [isShowProductLookupModal, setIsShowProductLookupModal] = useState(false);
  const [showUpdateProgressModal, setShowUpdateProgressModal] = useState(false);
  const [laborCodesObject, setLaborCodesObject] = useState([]);
  const [sitesUpdated, setSitesUpdated] = useState(0);
  const { distinctLaborCodes } = useSelector((state) => state.siteRepo);
  const selectedSites = sites.filter((site) => site.isSelected);

  useEffect(() => {
    if (!distinctLaborCodes?.length) dispatch(getlaborCodeOptions());
  }, []);

  const onProductSelection = (productData) => {
    setUpdatedBySelectedProduct(productData);
    setIsShowProductLookupModal(false);
  };

  const performBulkUpdate = async () => {
    setShowUpdateProgressModal(true);
    const commonPayload = {
      updatedBy: sub,
      newProductName: updatedBySelectedProduct.productName,
      newSalesNumber: updatedBySelectedProduct.salesNumber,
      newCategoryCode: updatedBySelectedProduct.categoryCode,
      oldProductName: selectedProduct.productName,
      oldSalesNumber: selectedProduct.salesNumber,
      oldCategoryCode: selectedProduct.categoryCode,
      laborCodes: laborCodesObject.map((item) => ({
        id: item.id,
        laborCodeDesc: item.description,
        laborCodeDescExt: item.descriptionExt,
        laborCode: item.laborCode,
      })),
    };

    const updateQueue = selectedSites.map(({ siteId }) => {
      return async () => axios.post(`/fc-site-repo/bulkUpdateProduct`, { ...commonPayload, siteId });
    });

    Promise.all(
      [...Array(4)].map(async () => {
        while (!isEmpty(updateQueue)) {
          try {
            await updateQueue.pop()();
            setSitesUpdated((sitesUpdated) => sitesUpdated + 1);
          } catch (err) {
            console.err(err);
            toast.error(`An unexpected error occurred while updating a site`);
          }
        }
      }),
    ).then(() => {
      setShowUpdateProgressModal(false);
      toast.success("Bulk site update completed!");
      navigate("/siteRepo");
    });
  };

  return (
    <div className="container-fluid product-update-by mt-5">
      <div className="search-form-container__fields">
        <div className="search-form-container__fields__form">
          <div className="row final-selection">
            <ProductSummary title="Update From" {...selectedProduct} />
            {!isEmpty(updatedBySelectedProduct) && (
              <>
                <div className="col-1 d-flex align-items-center">
                  <img src={rightArrow} alt="" />
                </div>
                <ProductSummary title="Update To" {...updatedBySelectedProduct} />
              </>
            )}
          </div>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-12 search-form-container__fields__form-group mt-5">
              <Button variant="outline-primary" onClick={() => setIsShowProductLookupModal(true)}>
                Select a replacement product
              </Button>
            </div>
          </div>
          <div className="row align-items-center">
            <div>
              <h4 className="label_class account-info__header px-0">Add Labor Codes</h4>
              <p className="account-info__instruction px-0">
                Add the labor codes to the product selected. Labor codes will be added to the replacement product if the
                replacement product does not already have the specified labor codes.
              </p>
            </div>
            <div style={{ width: "30rem" }}>
              <Select
                key={laborCodesObject.length}
                options={sortBy(
                  (distinctLaborCodes ?? [])
                    .filter((lc) => !laborCodesObject.some((selectedlc) => selectedlc.id === lc.id))
                    .map((lc) => ({ value: lc.id, label: `${lc.laborCode} ${lc.description}` })),
                  "label",
                )}
                onChange={({ value }) => {
                  const laborCode = distinctLaborCodes.find((lc) => lc.id === value);
                  if (laborCode !== undefined) {
                    setLaborCodesObject([...laborCodesObject, laborCode]);
                  }
                }}
              />
            </div>
          </div>
          <div className="labor-codes-container d-flex w-100 flex-column">
            {laborCodesObject.map((laborCode, itemIndex) => (
              <div className="labor-codes-table-row d-flex" key={itemIndex} style={{ width: "fit-content" }}>
                <div className="labor-codes-table-row-cell" style={{ width: "3rem" }}>
                  <div className="d-flex flex-column">
                    {itemIndex === 0 ? <span className="label">Code</span> : ""}
                    <span>{laborCode.laborCode}</span>
                  </div>
                </div>
                <div className="labor-codes-table-row-cell cursor-pointer flex-grow ps-3" style={{ width: "26rem" }}>
                  <div className="d-flex flex-column">
                    {itemIndex === 0 ? <div className="label">Description</div> : ""}
                    <div>
                      {laborCode.description ? (
                        <CustomTooltip
                          placement="top"
                          trigger="hover"
                          text={`${laborCode.laborCode}- ${laborCode.description}: ${laborCode.descriptionExt}`}
                        >
                          <span>{laborCode.description}</span>
                        </CustomTooltip>
                      ) : (
                        "NA"
                      )}
                    </div>
                  </div>
                </div>
                <div className="ps-3" style={{ width: "3rem" }}>
                  <div className="d-flex flex-column margin-left-20 align-items-center">
                    {itemIndex === 0 ? <span className="label d-flex justify-content-center">Actions</span> : ""}
                    <img
                      src={deleteIconBlue}
                      alt="delete"
                      role="button"
                      onClick={() => setLaborCodesObject(laborCodesObject.filter((lc) => lc.id != laborCode.id))}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end flex-column-reverse flex-md-row">
        <Button
          className="me-0"
          variant="primary"
          onClick={performBulkUpdate}
          disabled={isEmpty(updatedBySelectedProduct)}
        >
          Update product in {selectedSites.length} site{selectedSites.length === 1 ? "" : "s"}
        </Button>
      </div>

      {isShowProductLookupModal && (
        <CustomModal
          title="Select Product"
          handleSave={() => true}
          handleCancel={() => setIsShowProductLookupModal(false)}
          size="lg"
          sectionName=""
          closeButtonText="Cancel"
          rootClass="add-product-modal"
        >
          <ProductLookup onProductSelectionCallback={onProductSelection} isPriceQuote={false}></ProductLookup>
        </CustomModal>
      )}

      <Modal show={showUpdateProgressModal} centered>
        <Modal.Body>
          <div className="text-center mb-2">
            Bulk update in progress ({sitesUpdated}/{selectedSites.length} Completed)
          </div>
          <ProgressBar now={Math.round(100 * (sitesUpdated / selectedSites.length))} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProductUpdatedBy;
